import axios from 'axios';
import getBaseUrl from '@/utils/getUrl';

export const createOrder = async (apiKey, order) => {
  const baseUrl = `${getBaseUrl()}/wp-json/gff/v1`;
  const url = `${baseUrl}/add/order`
  return (await axios.post(url, order, {
    headers: {
      'Authorization': `Bearer ${apiKey}`
    }
  })).data;
}